export const readSearchParams = (
  href: string,
  names: readonly string[],
): URLSearchParams => {
  const { searchParams } = new URL(href);
  const params = new URLSearchParams();

  names.forEach((name) => {
    const value = searchParams.get(name);

    if (value !== null) {
      params.set(name, value);
    }
  });

  return params;
};

export const isOnPathname = (
  currentPathname: string,
  pathname?: string,
): boolean => pathname === undefined || currentPathname === pathname;
